import {Drawer} from "antd";
import styled from "styled-components";

export const StyledSessionDetailsDrawer = styled(Drawer)`
  .ant-drawer-content-wrapper {
    width: 100% !important;
    @media (min-width: 767px) {
      width: 68.2rem !important;
    }
  }
`;
